import { render, staticRenderFns } from "./BookmarkDialog.vue?vue&type=template&id=7aa386f9&scoped=true"
import script from "./BookmarkDialog.vue?vue&type=script&lang=js"
export * from "./BookmarkDialog.vue?vue&type=script&lang=js"
import style0 from "./BookmarkDialog.vue?vue&type=style&index=0&id=7aa386f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa386f9",
  null
  
)

export default component.exports